/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_LabelInputs */

const en_faq_label = /** @type {(inputs: Faq_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions & answers`)
};

const lv_faq_label = /** @type {(inputs: Faq_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jautājumi un atbildes`)
};

/**
* | output |
* | --- |
* | "Questions & answers" |
*
* @param {Faq_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_label = /** @type {((inputs?: Faq_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_label(inputs)
	return en_faq_label(inputs)
});